import styled, {css, keyframes} from "styled-components";
import {Colors} from "./Colors";

export const Animations = {

    blinking: keyframes`
        0%, 100% {
            opacity: 1;
            filter: drop-shadow(0 0 2px ${Colors.raw.neon_orange});
        }
    
        50% {
            opacity: 0.25;
            filter: drop-shadow(0 0 10px ${Colors.raw.neon_orange});
        }
    `
}

const Styles__ = {
    eMail: {
        Frame: styled.div`
            width: 100%;
            display: flex;
            min-height: 10px;
            overflow: hidden;
        `,
        StyledTinyLeftBar: styled.div<{ isNew: boolean }>`
            height: inherit;
            width: 5px;
            background-color: ${ p => p.isNew ? Colors.raw.amber_bright :Colors.raw.neon_orange};
            border-top-left-radius: 3px;
            border-bottom-left-radius: 3px;
            ${p => p.isNew && css`
                animation: ${Animations.blinking} 1.5s infinite ease-in-out;
            `}
        `,
        BackgroundHeader: styled.div`
            background-color: rgba(255, 255, 255, 0.2);
            padding: 10px;
            width: calc(100% - 20px);
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
            text-align: left;
            &:hover {
                cursor: pointer;
                background-color: rgba(255, 255, 255, 0.3);
            }
        `
    },
    DataPad: {
        HeaderLowerBar: styled.div`
            position: relative;
            width: 100%;
            height: 15px;
            background-color: ${Colors.raw.neon_orange};
            overflow: hidden;
            //box-shadow:
            //    0 -4px 8px -3px rgba(245, 220, 255, 1),
            //    0 -8px 18px -6px rgba(210, 80, 255, 0.95),
            //    0 -14px 30px -10px rgba(180, 0, 255, 0.85),
            //    0 -20px 45px -16px rgba(140, 0, 255, 0.65);
        `,
        ColorDiv: styled.div<{ pos: string }>`
            background-color: ${Colors.raw.petrol_dark};
            height: 80%;
            width: 50px;
            position: absolute;
            bottom: 0;
            left: ${p => p.pos === 'left' ? '0' : undefined};
            right: ${p => p.pos === 'right' ? '0' : undefined};
        `,
        SquareRotated: styled.div<{ pos: string }>`
            background-color: ${Colors.raw.petrol_dark};
            height: 20px;
            width: 20px;
            position: absolute;
            bottom: -12px;
            rotate: 45deg;
            left: ${p => p.pos === 'left' ? '41px' : undefined};
            right: ${p => p.pos === 'right' ? '41px' : undefined};
        `
    }
}


export const Styles = {
    Init: styled.div`
        background-color: ${ Colors.raw.petrol_dark };
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        font-family: "Share Tech Mono", monospace;
        font-weight: bold;
        color: ${ Colors.raw.terminal_light };
    `,
    DataPad: {
        Header: {
            Frame: styled.div`
                width: 100%;
                padding: 10px 20px;
                display: flex;
                justify-content: left;
                font-size: xx-large;
                text-transform: uppercase;
                padding-right: 50px !important;
                overflow: hidden;
            `,
            Button: {
                Close: styled.button`border: 2px solid ${Colors.raw.terminal_light};
                    width: 20px;
                    height: 20px;
                    border-radius: 10%;
                    display: flex;
                    justify-content: center;
                    position: absolute;
                    top: 15px;
                    right: 20px;
                    padding: 0;
                    background: transparent;
                    color: ${Colors.raw.terminal_light};
                    font-family: inherit;
                    font-weight: bold;
                    line-height: 1;
                    cursor: pointer;

                    &::before {
                        content: "×";
                        font-size: 18px;
                        line-height: 1;
                    }
                `
            },
            Closing: () => <Styles__.DataPad.HeaderLowerBar>
                    <Styles__.DataPad.ColorDiv pos={'left'}/>
                    <Styles__.DataPad.SquareRotated pos={'left'}/>
                    <Styles__.DataPad.SquareRotated pos={'right'}/>
                    <Styles__.DataPad.ColorDiv pos={'right'}/>
                </Styles__.DataPad.HeaderLowerBar>,
        },
        Footer: {
            Frame: styled.div`
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 80px;
                background-color: ${Colors.raw.petrol_dark};
                overflow: hidden;
            `,
        }
    },
    OuterFrame: styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background-color: #f5f5f5;
    `,

    eMail: {
        Frame: styled.div`
            padding: 20px 40px;
            padding-bottom: 5px;
            max-height: calc(100vh - 100px);
        `,
        Header: ({ children, onClick, isNew } :
                 { children: React.ReactNode, onClick?: () => void, isNew?: boolean }) =>
            <Styles__.eMail.Frame>
                <Styles__.eMail.StyledTinyLeftBar isNew={ !! isNew } />
                <Styles__.eMail.BackgroundHeader onClick={ onClick }>{children}</Styles__.eMail.BackgroundHeader>
            </Styles__.eMail.Frame>,
        Content: styled.div`
            text-align: left;
            padding-top: 20px;
            overflow-y: auto;
            overflow-x: hidden;
            white-space: pre-line;
            padding-bottom: 40px;
        `,
    },
    Input: {
        button: {
            primary: styled.button`
                padding: 5px 10px;
                border-color: ${Colors.schemas.primary};
                border-style: solid;
                border-width: 2px;
                border-radius: 5px;
                background-color: ${Colors.schemas.background};
                color: ${Colors.raw.white};
                font-weight: bold;
            `,
            secondary: styled.button`
                padding: 5px 10px;
                border-color: ${ Colors.schemas.primary };
                border-style: solid;
                border-width: 2px;
                border-radius: 5px;
                background-color: ${ Colors.schemas.background };
                color: ${ Colors.raw.white };
                font-weight: bold;
                &:disabled {
                    opacity: 0.2;
                }
            `,
        }
    }
}